import { t } from '@lingui/core/macro';
import { RohsVersion } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export function formatRohsVersion(value: RohsVersion): string {
    switch (value) {
        case RohsVersion.Rohs_2002_95_EC:
            return t`RoHS (2002/95/EC)`;
        case RohsVersion.Rohs2_2011_65_EU:
            return 'RoHS2 (2011/65/EU)';
        case RohsVersion.Rohs2_2015_863_EU:
            return 'RoHS2 (2015/863/EU)';
        default:
            assertUnreachable(value);
    }
}
